import services from '../../services'

const state = {
    hotHoteList: [],
    exhiConfigInfo: {
        timeZone: '8',
        currencySymbol: '$',
        defaultCurrency: '￥',
        baiduLongitude: '',
        baiduLatitude: '',
        googleLongitude: '',
        googleLatitude: '',
        housingMaximum: '',
        checkInDaysMax: 2,
        exhiId: '',
        nameCn: '',
        nameEn: '',
        volumeMaximum: '',
        activeExhiItem: null,
        startDate: '',
        endDate: ''

    }
}

const mutations = {

    /**
     * 设置热门酒店列表数据
     * @param {*} state
     * @param {*} payload
     */
    setHotHotelListData(state, payload) {
        state.hotHoteList = payload && payload.data && payload.data.data || []
    },

    /**
     * 设置展会配置信息
     * @param {*} state
     * @param {*} payload
     */
    setExhiConfigInfo(state, payload) {
        state.exhiConfigInfo = payload.data || {}
    },

    /**
     * 设置展会首页当前轮播的展会ID
     * @param {*} state
     * @param {*} payload
     */
    setCurrentExhiItem(state, payload) {
        state.activeExhiItem = payload
    }
}

const actions = {

    // 获取展会配置信息
    getResExhiConfig(context, param) {
        return new Promise((resolve, reject) => {
            services.homeSer.getResExhiConfig(param).then((res) => {
                console.log(res.data, '-----res.data')
                context.commit('setExhiConfigInfo', res.data || {})
                resolve(res)
            })
        })
    },
    // 获取展会业务锁逻辑
    getResBusinessLock(context, param) {
        return new Promise((resolve, reject) => {
            services.homeSer.getResBusinessLock(param).then((res) => {
                resolve(res)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
